import { useEffect, useState } from "react";
import DashboardLayout, { StatCard, EmptyState } from "./DashboardLayout";
import { LayoutDashboard, Award, BookOpen, CalendarCheck, Loader2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import api from "@/lib/api";

const NAV = [{ key: "overview", label: "Child Progress", icon: LayoutDashboard }];

export default function ParentDashboard() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/parent/dashboard").then((r) => setData(r.data)).catch(() => setData({})); }, []);
    if (!data) return <DashboardLayout nav={NAV} active="overview" title="Parent Dashboard"><div className="grid place-items-center py-20"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div></DashboardLayout>;

    const enr = data.enrollments?.[0];
    return (
        <DashboardLayout nav={NAV} active="overview" title="Parent Dashboard">
            {data.child ? (
                <div className="space-y-6">
                    <Card className="p-6 flex items-center gap-4">
                        <span className="grid h-14 w-14 place-items-center rounded-2xl bg-primary/10 text-primary font-heading font-bold text-xl">{data.child.name[0]}</span>
                        <div><p className="text-sm text-foreground/50">Viewing progress for</p><h2 className="font-heading text-xl font-bold">{data.child.name}</h2></div>
                    </Card>
                    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
                        <StatCard icon={CalendarCheck} label="Attendance" value={`${data.attendance}%`} color="success" />
                        <StatCard icon={BookOpen} label="Programs" value={(data.enrollments || []).length} />
                        <StatCard icon={Award} label="Certificates" value={(data.certificates || []).length} color="accent" />
                    </div>
                    {enr && (
                        <Card className="p-6">
                            <h3 className="font-heading font-bold">{enr.program_title}</h3>
                            <div className="mt-3 flex justify-between text-sm text-foreground/60 mb-1"><span>Learning progress</span><span>{enr.progress}%</span></div>
                            <Progress value={enr.progress} className="h-2" />
                            <p className="mt-3 text-sm text-foreground/60">Current lesson: {enr.current_lesson}</p>
                        </Card>
                    )}
                    <Card className="p-6">
                        <h3 className="font-heading font-bold mb-4">Achievements</h3>
                        {(data.certificates || []).length ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {data.certificates.map((c) => <div key={c.id} className="flex items-center gap-3 rounded-xl border border-border p-3"><Award className="h-5 w-5 text-success" /><div><p className="text-sm font-medium">{c.program}</p><Badge className="bg-success/15 text-success border-0 mt-1">{c.status}</Badge></div></div>)}
                            </div>
                        ) : <p className="text-sm text-foreground/50">No certificates yet.</p>}
                    </Card>
                </div>
            ) : <EmptyState icon={LayoutDashboard} title="No child linked" desc="Contact your counselor to link your child's account." />}
        </DashboardLayout>
    );
}
